"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ToggleIcon = require("./ToggleIcon");
Object.keys(_ToggleIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ToggleIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ToggleIcon[key];
    }
  });
});